import { createAction, props } from '@ngrx/store';
import { CacheItemInterface } from '../../interfaces/cache-item.interface';

export const addItem = createAction('[Cache] Add Item', props<{ payload: CacheItemInterface }>());

export const removeItem = createAction('[Cache] Remove Item', props<{ payload: string }>());

export const clear = createAction('[Cache] Clear');
